import React from 'react'
import {Link as ScrollLink} from "react-scroll/modules";

class BackButtons extends React.Component {
    render() {
        const {backElement} = this.props
        return (
            <div className="actionsBackandTop">
                <ScrollLink className="button icon small fa-arrow-left" activeClass="active" to={backElement} spy={true}
                                smooth={true} duration={250}>Indietro</ScrollLink>
                <ScrollLink className="button icon small fa-arrow-up" activeClass="active" to="topElements" spy={true}
                                smooth={true} duration={250}>Top</ScrollLink>
            </div>
        )
    }
}
export default BackButtons
